import { axiosApi } from "../helpers/api_helper";

export class StoreSubscriptionsRepository {
  endpoint = "/store_subscriptions";

  async getSubsciption() {
    const response = await axiosApi.get(`${this.endpoint}`);
    return response.data;
  }

  async getRedeemedPrizes(params = {}) {
    const response = await axiosApi.get(
      `${this.endpoint}/redeemed-prizes-list`,
      { params }
    );
    return response.data;
  }

  async getMembers(params = {}) {
    const response = await axiosApi.get(`${this.endpoint}/member-list`, {
      params
    });
    return response.data;
  }

  async getMemberInfo(id) {
    const response = await axiosApi.get(
      `${this.endpoint}/member-all-info/${id}`
    );
    return response.data;
  }

  async getProductSubscription() {
    const response = await axiosApi.get(
      `${this.endpoint}/subscription-product`
    );
    return response.data;
  }

  async getSelectedSubscription(id) {
    const response = await axiosApi.get(
      `${this.endpoint}/subscription-product/${id}`
    );
    return response.data;
  }
}

//http://localhost:3000/store_subscriptions/subscription-product/1

export default StoreSubscriptionsRepository;
